import { Injectable } from '@angular/core';
import { SubBoardListItemModel } from '../models/sub-board-list-item-model';

@Injectable({
    providedIn: 'root'
})
export class SubBoardRequestsCacheService {
    private requestsCache: SubBoardListItemModel[];

    constructor() {}

    public refreshCache(requests: SubBoardListItemModel[]) {
        this.requestsCache = requests;
    }

    public getSubBoardLiteItemModelById(id: string): SubBoardListItemModel {
        if (!this.requestsCache) {
            return null;
        }

        return this.requestsCache.find(x => x.id === id);
    }
}
